export const handleUserKeyPress = (event, player) => {
    
    const { keyCode, shiftKey, ctrlKey } = event;
    var e = event || window.event,
        target = e.target || e.srcElement;
    if (
        !(shiftKey || ctrlKey || ['INPUT', 'TEXTAREA'].includes(target.tagName.toUpperCase()))
    ) {
        if (keyCode === 27) {
            player.isFullscreen()
                ? player.exitFullscreen() : ""
           // closeModals()
        }
        if (keyCode === 32 || keyCode === 75 || keyCode === 80 ) {
            // Action : play/pause
            // keys: k / space 
            player.paused() ? player.play() : player.pause();
        }
        if (keyCode == 77) {
            player.muted(!player.muted())
        }
        if (keyCode === 79) {
            console.log('open settings modal');
        }
        if (keyCode === 72) {
            console.log('open chapters modal');
        }
        if (keyCode === 76) {
            player.currentTime(player.currentTime() + 10)
        }
        if (keyCode === 74) {
            player.currentTime(player.currentTime() - 10)
        }         
        if (keyCode == 107 || keyCode == 38 && player.volume() < 1) {
            player.volume(player.volume() + 0.2)
        }
        if (keyCode == 109 || keyCode == 40 && player.volume() > 0) {
            player.volume(player.volume() - 0.2)
        }
        if (keyCode == 70) {
            player.isFullscreen()
                ? player.exitFullscreen() : player.requestFullscreen()
        }
    }
}